﻿import {AccessToken} from "./types";
import {Ref, unref} from "vue";
import {useMateApi} from "./useMateApi";

interface CrudReadOptions {
    skip: number;
    take: number;
}

export enum DocumentGroup {
    SalesPeriod = "sales-period",
    Sales = "sales",
    CustomerService = "customer-service",
    Logistic = "logistic",
    Inventory = "inventory"
}

export enum DocumentType {
    SalesReceipt = "sales-receipt",
    CreditNote = "credit-note",
    AdvancePayment = "advance-payment",
    Voucher = "voucher",
    PurchaseOnInvoice = "purchase-on-invoice",
    SalesReceiptReportReference = "sales-receipt-report-reference",

    CustomerOrder = "customer-order",
    CustomerRepairOrder = "customer-repair-order",
    CustomerRepairOrderContainer = "customer-repair-order-container",
    CustomerOffer = "customer-offer",
    Reservation = "reservation",
    CustomerLoan = "customer-loan",
    IntermediateDocument = "intermediate-document",

    Order = "order",
    Incoming = "incoming",
    IncomingDemand = "incoming-demand",
    Relocation = "relocation",
    RelocationDemand = "relocation-demand",
    Return = "return",
    ItemContainer = "item-container",
    
    DailyOpening = "daily-opening",
    DailyClosing = "daily-closing",
    DailyClosingPreview = "daily-closing-preview",
    CashCheck = "cash-check",
    OpenCashDrawer = "open-cash-drawer",
    ShopClosing = "shop-closing",
    MonthlyClosing = "monthly-closing",

    Inventory = "inventory",
    InventoryRegistration = "inventory-registration",
    InventoryClosing = "inventory-closing",
    StockMessage = "stock-message",
    StockCorrection = "stock-correction",

    Deposit = "deposit",
    Expense = "expense",
    LocationSafeDeposit = "location-safe-deposit",
    LocationSafeExpense = "location-safe-expense",
    ServiceReceipt = "service-receipt",
    Message = "message"
}

export const useDocumentApi = (
    documentGroup: string | Ref<DocumentGroup> | undefined,
    documentType: string | Ref<DocumentType>,
    accessToken: AccessToken) => {

    const {jsonEndpoint} = useMateApi(accessToken)
    const url = () => `/api/documents/${unref(documentType)}`;
    const api = () => jsonEndpoint(url());
    const pascalCase = true;

    const key = (entity: any) => {
        //console.log("KEY", entity);
        return `${entity.Uid}`;
    };

    const read = <TEntity = any>(uid: string) =>
        api().get<TEntity[]>({uid}, {pascalCase}).then(list => list[0])

    const readList = <TEntity = any>(params: any, options: CrudReadOptions) =>
        api().get<TEntity[]>({
            ...params,
            skip: options.skip,
            take: options.take
        }, {pascalCase})


    return {
        key,
        read,
        readList,
    }
};
